<template>
	<div v-if="mostrarMsgSinRegistros" class="text-center">
		<span>No hay más datos</span>
	</div>
	<div v-else>
		<div v-for="edificio in edificios" :key="edificio.id">
			<form :id="id+'-form'">
				<div class="card mb-4">
					<div class="card-body">
						<div class="d-flex justify-content-between">
							<div>
								<h5 v-text="`${edificio.nombre} - ${edificio.clave}`" class="card-title mb-1"></h5>
								<h6 v-text="`Tipo: ${edificio.tipo}`" class="card-subtitle m-0 text-muted"></h6>
							</div>
							<div class="mt-2">
								<button type="button" data-target="#editarEdificio" data-toggle="modal" v-bind:id="'edificio-'+edificio.id" :key="'key-edificio-'+edificio.id" class="btn btn-primary btn-sm">
									<span hidden v-text="edificio.id" class="btnModalGetClass"></span>
									Editar	edificio
								</button>
								<button type="button" data-target="#crearAula" data-toggle="modal" v-bind:id="'aula-'+edificio.id" :key="edificio.id" class="btn btn-success btn-sm">
									<span hidden v-text="edificio.id" class="btnModalGetClass"></span>
									Crear aula
								</button>
							</div>
						</div>
					</div>
					<div class="card-footer text-muted p-0 m-0">
						<div style="display: flex; justify-content: flex-start; flex-wrap: wrap; text-align: center; padding: 15px">
							<div class="border" style="width: 120px; max-width: 120px; margin: 5px; height: 90px;" v-for="aula in edificio.aulas" :key="'key-aula-'+aula.id">
								<button
								type="button"
								data-target="#editarAula"
								data-toggle="modal"
								v-bind:id="aula.id"
								:key="aula.id"
								class="btn btn-primary btn-sm"
								style="width:100%; height:100%; padding:10px;"
								:title="`Editar aula ${aula.nombre}`">
								<i class="fas fa-chalkboard" style="font-size: 1.7em; text-align:center; margin:10px;"></i>
								<p>{{ aula.nombre }}</p>
								<span hidden v-text="aula.id" class="btnModalGetClass"></span>
							</button>
						</div>
					</div>
				</div>
			</div>
		</form>
	</div>
</div>
</template>
<script>
import Axios from 'axios';
export default {
	props: [
	'title',
	'id',
	],
	data() {
		return {
			mostrarMsgSinRegistros: false,
			edificios: []
		}
	},
	mounted () {
		const vm = this;

		$('#plantel_id').on('change', function(e) {
			const plantelId = $(this).val();
			vm.filtrarEdificios(plantelId);
		});
	},
	methods: {
		filtrarEdificios(plantelId) {
			axios.get(`planta-fisica/edificios/filtrar?plantel_id=${plantelId}`)
                .then(response => {this.edificios = response.data; this.mostrarMsgSinRegistros = response.data.length != 0 ? false : true;})
                .catch(e => { toastr["error"]('Ocurrió un problema inesperado', 'Error'); });
		}
	}

};
</script>
